import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useToast } from '@cmpsr/components';
import IntroWizard from './components/intro-wizard/intro-wizard';
import Questionnaire from './components/questionnaire/questionnaire';
import useQuestionnaireController from './questionnaire.controller';
import { Status } from './types';

export default function QuestionnairePage() {
  const toast = useToast();
  const { backOnFirstSurveyItem, handleFinishIntroWizard, status, uploadAnswers, userQuestionnaire } =
    useQuestionnaireController();

  switch (status) {
    case Status.ready:
      return <IntroWizard onFinish={handleFinishIntroWizard} />;
    case Status.inProgress:
      if (userQuestionnaire) {
        return (
          <Questionnaire
            userQuestionnaire={userQuestionnaire}
            decisionTreeCallback={uploadAnswers}
            backOnFirstSurveyItem={backOnFirstSurveyItem}
          />
        );
      } else {
        toast({
          ...TOAST_DEFAULT_OPTIONS,
          title: 'Error',
          description: 'Error connecting to the Catch server.',
          status: 'error',
        });
      }
      break;
  }
}
